import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { Language } from "../../Types";
import { CategoriesContainer } from "../splash-scene/categories/CategoriesContainer";
import { CategoryLayer } from "../splash-scene/categories/CategoryLayer";

export class TitleLayer extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        const gameText = this.scene.cache.json.get("text");
        const lan = GameVars.gameData.data.language;

        const background = new Phaser.GameObjects.Graphics(scene);
        background.fillStyle(0x000000);
        background.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        this.add(background);    

        const titleContainer = new Phaser.GameObjects.Container(scene); 
        titleContainer.x = GameConstants.GAME_WIDTH / 2;
        titleContainer.y = GameConstants.GAME_HEIGHT / 2;
        titleContainer.scaleX = .9 * GameVars.scaleX;
        titleContainer.scaleY = .9;
        titleContainer.alpha = 0;
        this.add(titleContainer);

        const levelTitleBackground = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "level_title_background");
        titleContainer.add(levelTitleBackground);

        const menuTitleBackground = new Phaser.GameObjects.Image(this.scene, -255, -55, "texture_atlas_1", "tab_boards_daily_games");
        menuTitleBackground.setOrigin(0);
        titleContainer.add(menuTitleBackground);

        const levelTitle = new Phaser.GameObjects.Text(this.scene, menuTitleBackground.x + 30, menuTitleBackground.y + 18, GameVars.boardsData[GameVars.levelIndex].name.toUpperCase(), {fontFamily: "OpenSans-CondLight", fontSize: "120px", color: "#7C5D46"});
        levelTitle.setOrigin(0);

        let width = levelTitle.width;

        levelTitle.setScale(52 / levelTitle.height); 

        width *= levelTitle.scale;

        if (width > 320) {
            levelTitle.setScale(340 / levelTitle.width);
        }
        
        titleContainer.add(levelTitle);

        if (GameVars.currentDay) {
            
            const monthStr = gameText[GameConstants.MONTHS[GameVars.currentDay.month - 1].toUpperCase()][lan];
            const dateStr = GameVars.currentDay.day + " " + monthStr + " " + GameVars.currentDay.year;

            const currentDayLabel = new Phaser.GameObjects.Text(this.scene, 0, 32, dateStr, {fontFamily: "Arial", fontSize: "22px", color: "#7C5D46", fontStyle: "bold"});
            currentDayLabel.scaleX = .8;
            currentDayLabel.setOrigin(.5);
            titleContainer.add(currentDayLabel);
        } 

        const capsule = new Phaser.GameObjects.Graphics(this.scene);
        capsule.fillStyle(0x776756);
        capsule.fillRoundedRect(-130, 85, 260, 60, 30);
        titleContainer.add(capsule);

        const category = GameVars.boardsData[GameVars.levelIndex].cat;

        const index = CategoryLayer.CATEGORIES.indexOf(category) + 1;

        const key = CategoriesContainer.CATEGORIES_DATA[index - 1].key;

        const categoryImg = new Phaser.GameObjects.Image(scene, -90, 114, "texture_atlas_1", "icon_" + index);
        titleContainer.add(categoryImg);

        let categoryStr = gameText[key][lan];
        categoryStr = categoryStr.charAt(0).toUpperCase() + categoryStr.slice(1).toLowerCase();

        const categoryLabel = new Phaser.GameObjects.Text(this.scene, 15, 114, categoryStr, {fontFamily: "Arial", fontSize: "32px", color: "#FFF4A8", fontStyle: "bold"});
        categoryLabel.setOrigin(.5);
        categoryLabel.scaleX = .8;
        titleContainer.add(categoryLabel);

        this.scene.tweens.add({
            targets: titleContainer,
            alpha: 1,
            scaleX: GameVars.scaleX,
            scaleY: 1,
            duration: 800,
            delay: 1000,
            ease: Phaser.Math.Easing.Cubic.Out
        });
    
        this.scene.tweens.add({
            targets: background,
            alpha: .6,
            duration: 1000,
            ease: Phaser.Math.Easing.Cubic.In
        });

        this.scene.tweens.add({
            targets: background,
            alpha: 0,
            duration: 1000,
            delay: 2500,
            ease: Phaser.Math.Easing.Cubic.Out
        });

        // El título del nivel desaparece con tween a escala 105% y alpha 0% en 1s ease OUT.
        this.scene.tweens.add({
            targets: titleContainer,
            alpha: 0,
            scaleX: 1.05 * GameVars.scaleX,
            scaleY: 1.05,
            duration: 1000,
            delay: 2500,
            ease: Phaser.Math.Easing.Cubic.Out,
            onComplete: () => {
                this.destroy();
            },
            onCompleteScope: this
        });
    }
}
